// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/stylesheets/layout/footer.styl
// module id = 340
// module chunks = 0